import { render, staticRenderFns } from "./detailTop.vue?vue&type=template&id=3c2f58f4&scoped=true"
import script from "./detailTop.vue?vue&type=script&lang=js"
export * from "./detailTop.vue?vue&type=script&lang=js"
import style0 from "./detailTop.vue?vue&type=style&index=0&id=3c2f58f4&prod&lang=scss&scoped=true"
import style1 from "./detailTop.vue?vue&type=style&index=1&id=3c2f58f4&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c2f58f4",
  null
  
)

export default component.exports